import { useState } from "react";
import text from '../lib/dictionary.json';
import { useAuth } from "../AuthProvider";
import { Badge, IconButton, Tooltip } from "@mui/material";
import './sidenav.css';
import '../pages/modal.css';
import Notifications from "../components/Notifications";
import AutoManual from '../components/modular/AutoManual';
import { ThemeDarkIcon, ThemeLightIcon, PersonIcon, NotificationsIcon } from '../Icons';
import BuildingDropdown from "./BuildingDropdown";

const BTN_SX = {
    '&': {
        width: 40, height: 40,
        color: 'var(--root-color)',
        transition: 'outline .3s ease'
    },
    '&:hover': {
        color: 'var(--root-color)',
        outline: '6px solid rgba(0, 0, 0, 0.05)'
    }
};

const BADGE_SX = {
    '&': {
        width: 40, height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        cursor: 'pointer',
        color: 'var(--root-color)',
        transition: 'outline .3s ease'
    },
    '&:hover': {
        color: 'var(--root-color)',
        outline: '6px solid rgba(0, 0, 0, 0.05)'
    },
    '& .MuiBadge-badge': {
        backgroundColor: 'var(--error-bg)',
        color: 'white',
        width: 24,
        height: 22,
        borderRadius: 20,
        fontSize: 10,
        top: 8,
        right: 5
    }
};


const Header = () => {
    const {
        lang,
        theme,
        setTheme,
        user,
        setUser,
        setOpenSettings,
        model
    } = useAuth();
    const [openNotifications, setOpenNotifications] = useState({ open: false, notifications: 0 });
    const changeTheme = () => {
        const newTheme = theme === 'dark-theme' ? 'light-theme' : 'dark-theme';
        setTheme(newTheme);
        setUser({
            ...user,
            settings: user.settings ? {
                ...user.settings,
                others: { ...user.settings.others, theme: newTheme }
            } : { others: { theme: newTheme } }
        });
    };

    return (
        <div className="header" >
            <BuildingDropdown/>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <IconButton  onClick={changeTheme} sx={BTN_SX}>
                    <Tooltip title={text[lang]?.[theme] ?? ''}>
                        <span>{theme === 'light-theme'
                            ? <ThemeLightIcon />
                            : <ThemeDarkIcon />}
                            </span>
                        <span>
                            {/* <ThemeLightIcon /> */}
                        </span>
                    </Tooltip>
                </IconButton>
                <div style={{ position: 'relative' }}>
                    <Badge
                        badgeContent={openNotifications.notifications}
                        max={99}
                        onClick={() => setOpenNotifications(prev => ({ ...prev, open: true }))}
                        sx={BADGE_SX}>
                        <Tooltip title={text[lang]['notifications']}>
                            <span>
                                <NotificationsIcon />
                            </span>
                        </Tooltip>
                    </Badge>
                </div>
                <IconButton onClick={() => setOpenSettings(true)} sx={BTN_SX}>
                    <Tooltip title={text[lang]['settings']}>
                        <span>
                            <PersonIcon />
                        </span>
                    </Tooltip>
                </IconButton>
            </div>
            <Notifications state={openNotifications} setState={setOpenNotifications} />
        </div>
    );
};

export default Header;